/**
 * @file かんたん団検索
 */
'use strict';

import ApplyClass from '../../Utils/ApplyClass';
import BtnRemoveTitleField from './BtnRemoveTitleField';
import Validate from './Validate';
 
/**
 * @classname BtnGroupEasySearch
 * @classdesc かんたん団検索
 */
export default class BtnGroupEasySearch {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('btn-group-easy-search')
	 */
	constructor($e, controller) {
		console.log('BtnGroupEasySearch.constructor')
		this._$e = $e
		this._controller = controller;
		this._$input = $('#group_name');
		this._$e.on('click', () => this.groupEasySearch());
		this._controller.on('groupEasySearchComplete', () => this.groupEasySearchComplete());
		this._controller.on('onGetEasySearchDistrictsGroupsComplete', () => this.onGetEasySearchDistrictsGroupsComplete());
	}
 

	/**
	 * clickのコールバック
	 *
	 * @memberof BtnGroupEasySearch
	 * @return {undefined}
	 */
	groupEasySearch() {
		console.log('BtnGroupEasySearch.groupEasySearch');
		const val = this._$input.val();
		if(val === '') {
			this._$input
				.addClass('is-invalid')
				.closest('.form-group')
				.find('.error-tip')
				.addClass('show')
				.find('.error-tip-inner')
				.html('<p>この項目は必須です。</p>');
		} else {
			this._controller.groupEasySearch(val);
		}
	}


	/**
	 * clickのコールバック
	 *
	 * @memberof BtnGroupEasySearch
	 * @return {undefined}
	 */
	groupEasySearchComplete() {
		console.log('BtnGroupEasySearch.groupEasySearchComplete');
		this._data = this._controller._data;
		console.log(this._data);
		this._searchResults = this._data.search_results;
		const alert = '<div class="fade show alert alert-warning alert-dismissible">検索結果が50件を超えたため、50件目までを表示しています。もう少し検索を絞り込んでください。<button class="close" type="button" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">×</span></button></div>';
		$('#easySearchResult').html('');
		if(this._searchResults.length > 50) {
			$('#easySearchResult').html(alert);
		}
		let table = `
<table class="table table-responsive-sm table-bordered table-striped table-sm table-saj">
	<thead class="thead">
		<tr class="tr">
			<th class="th">連盟</th>
			<th class="th">地区</th>
			<th class="th">団</th>
			<th class="th">選択</th>
		</tr>
	</thead>
	<tbody class="tbody">`;
		for (let i = 0; i < this._searchResults.length; i++) {
			if(i === 50) break;
			table += `
		<tr class="tr">
			<td class="td">${this._searchResults[i].council_name}</td>
			<td class="td">${this._searchResults[i].district_name}</td>
			<td class="td">${this._searchResults[i].group_name}</td>
			<td class="td tac">
				<button type="button" class="btn-primary btn-sm btn-set-data" data-group-id="${this._searchResults[i].group_id}">設定</button>
			</td>
		</tr>`;
		}
		table += `
	</tbody>
</table>`;
		$('#easySearchResult').append(table);
		$('.btn-set-data').on('click', e => this.onClick(e));
	};


	/**
	 * clickのコールバック
	 *
	 * @memberof BtnGroupEasySearch
	 * @param {event} e - クリックイベント
	 * @return {undefined}
	 */
	onClick(e) {
		console.log('BtnGroupEasySearch.onClick');
		$('#modal-group-easy-search .close').click();
		$('#group_name').val('');
		$('#easySearchResult').html('');
		const groupId = $(e.currentTarget).attr('data-group-id');
		this._controller.getEasySearchDistrictsGroups(groupId);
	}


	/**
	 * 地区・団設定
	 *
	 * @memberof BtnGroupEasySearch
	 * @return {undefined}
	 */
	onGetEasySearchDistrictsGroupsComplete(e) {
		console.log('BtnGroupEasySearch.onGetEasySearchDistrictsGroupsComplete');
		this._searchResults = this._controller._data.search_results;
		const councilId = this._searchResults.council_id;
		const districtId = this._searchResults.district_id;
		const groupId = this._searchResults.group_id;
		this._districts = this._controller._data.districts;
		console.log(this._districts);
		this._groups = this._controller._data.groups;
		console.log(this._groups);
		let districtOptions = '<option value="">▼選択</option>';
		for (let i = 0; i < this._districts.length; i++) {
			districtOptions += `<option value="${this._districts[i].id}">${this._districts[i].name}</option>`;
		}
		let groupOptions = '<option value="">▼選択</option>';
		for (let i = 0; i < this._groups.length; i++) {
			groupOptions += `<option value="${this._groups[i].id}">${this._groups[i].name}</option>`;
		}
		$('.district_id').html(districtOptions);
		$('.group_id').html(groupOptions);
		$('.council_id').addClass('ignore').val(councilId);
		$('.district_id').addClass('ignore').val(districtId);
		$('.group_id').val(groupId);
		setTimeout(() => {
			$('.council_id').removeClass('ignore');
			$('.district_id').removeClass('ignore');
		},2000);
	};
}
